import { getTargetLabel } from "components/DataConsumption/DataScience/QualityAnalysis/ApproachableAI/utils";

import { getNodeChildren, getNodeData } from "./node";

const createLevelRepresentation = (targetId, nodeMap) => {
  const queue = [[nodeMap[targetId]]];
  let levelIndex = 0,
    maxLevel = 1;
  while (levelIndex < queue.length) {
    maxLevel = Math.max(queue[levelIndex].length, maxLevel);
    queue[levelIndex].forEach(node => {
      const children = getNodeChildren(node, nodeMap);
      if (children) {
        if (levelIndex + 1 === queue.length) queue.push([]);
        children.forEach(childId => {
          queue[levelIndex + 1].push(nodeMap[childId]);
        });
        node.type = levelIndex === 0 ? "output" : "default";
      } else {
        node.type = "input";
      }
    });
    ++levelIndex;
  }
  return { levels: queue, max: maxLevel };
};

const createNodes = (data, target, nodeMap) => {
  const targetLabel = target ? getTargetLabel(target) : "None";
  const { levels, max } = createLevelRepresentation(data.root_node_id, nodeMap);

  return levels.reduce((levelAcc, level, levelIndex) => {
    const levelNodes = level.reduce((nodeAcc, node, nodeIndex) => {
      const nodeData = getNodeData(
        node,
        levelIndex,
        levels.length,
        nodeIndex,
        level.length,
        max
      );
      if (levelIndex === 0) nodeData.data.label = targetLabel;

      return [...nodeAcc, nodeData];
    }, []);
    return [...levelAcc, ...levelNodes];
  }, []);
};

const createEdges = (nodes, nodeMap) =>
  nodes.reduce((acc, node) => {
    const nodeEdges = getNodeChildren(node, nodeMap)?.map(childId => ({
      id: `${node.id}-${childId}`,
      source: childId,
      target: node.id,
    }));
    return nodeEdges ? [...acc, ...nodeEdges] : [...acc];
  }, []);

const getGraph = (job, data, nodeMap) => {
  const initialNodes = createNodes(data, job?.job_settings?.target, nodeMap);
  const initialEdges = createEdges(data.nodes, nodeMap);
  return { initialNodes, initialEdges };
};

export { getGraph };
